<script setup>
import RHDigitalListPage from '@/components/rhdigital/list/RHDigitalListPage.vue'
import { RHDigitalSectorEntity } from '@/entities/RHDigitalSectorEntity.js'
import { getRHDigitalSectors } from '@/services/api/rhdigital.js'

const entity = new RHDigitalSectorEntity()
</script>

<template>
    <RHDigitalListPage :entity="entity" :fetcher="getRHDigitalSectors" />
</template>
